import { EntityFields } from './entity';
import { FieldOption } from './field-options';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';
import {
  SecurityAccess,
  SecurityAccessFieldOptions,
  SecurityAccessFieldOptionsResponse,
} from './security-access';
import { SecurityStatus } from './security-status';

export enum ImportTemplateFields {
  Name = 'Name',
}

export interface ImportTemplate {
  [EntityFields.Key]: string | null;
  [ImportTemplateFields.Name]?: string;
  [EntityFields.SecStatus]?: SecurityStatus;
  [EntityFields.SecAccess]?: SecurityAccess;
}

export interface ImportTemplateFieldOptions {
  ImportTemplate: FieldOption;
}

export interface ImportTemplateRequest extends Request {
  ImportTemplate: ReadRequest<ImportTemplate>;
}

export interface ImportTemplateResponse extends Response {
  ImportTemplate: DataResponse<ImportTemplate>;
}

export interface ImportTemplateFieldOptionsRequest extends Request {
  ImportTemplate: SecurityAccessFieldOptions;
}

export interface ImportTemplateFieldOptionsResponse extends Response {
  ImportTemplate: SecurityAccessFieldOptionsResponse;
}

export interface ImportTemplateModificationRequest extends Request {
  ImportTemplate: WriteRequest<ImportTemplate>;
}

export interface ImportTemplateModificationResponse extends Response {
  ImportTemplate: WriteResponse<ImportTemplate>;
}
